/* ==========================================================================
   Kaikan Cards — Gloed
   Kiest welke knoppen en kaarten de draaiende gouden rand krijgen en hangt
   er de lege spans in die kk-gloed.css tekent. De keuze staat hier op één
   plek, zoals de NACHT-lijst in kaikan-verzegeld.js.

   Zelf een rand toevoegen kan zonder dit bestand te openen: geef een element
   de klasse kk-gloed (altijd aan) of kk-gloed-hover (bij aanwijzen).

   Leeghalen van dit bestand zet alles terug zoals het was.
   ========================================================================== */
(function () {
  'use strict';

  /* Altijd aan: de hoofdknop van elke sectie, de koopknop, afrekenen, en de
     blokken die uitgelicht horen te zijn. */
  var ALTIJD = [
    /* knoppen */
    '.kkdh__knop',
    '.kkvs__knop--goud',
    '.kkzv__knop--vol',
    '.kkpb__knop',
    '.kks__knop',
    '.kkl__knop',
    '.kkdc__knop',
    '.kkpromo__cta',
    '.kkcb__knop',
    '.kkmb__btn--primary',
    '.product-form__submit.button--primary',
    'button.button--primary[name="checkout"]',
    /* uitgelichte blokken */
    '.kkpl__card--vitrine',
    '.kkvs__stop--jp',
    '.kkl__uit',
    '.kks__kaart',
    '.kkpromo',
    '.kk-gloed'
  ];

  /* Bij aanwijzen: productkaarten. Twintig draaiende randen tegelijk in een
     raster is onrustig; eentje onder je muis of duim is een beloning. */
  var HOVER = [
    '.kkpl__card',
    '.kkpb__kaart',
    '.product-card',
    '.kk-gloed-hover'
  ];

  if (!window.CSS || !CSS.supports || !CSS.supports('(-webkit-mask-composite: xor) or (mask-composite: exclude)')) return;

  var alleSelectors = ALTIJD.concat(HOVER).join(',');
  var altijdSelector = ALTIJD.join(',');
  var magAanwijzen = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  /* ---------- licht of donker ---------- */

  function kleuren(tekst) {
    var uit = [], re = /rgba?\(([^)]+)\)/g, m;
    while ((m = re.exec(tekst))) {
      var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat);
      if (p.length >= 3) uit.push({ r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 });
    }
    return uit;
  }

  function helderheid(k) {
    return (0.2126 * k.r + 0.7152 * k.g + 0.0722 * k.b) / 255;
  }

  /* Loopt omhoog tot er een vlak is dat echt dekt. Verlopen tellen mee:
     veel secties zetten hun zwart als gradient en niet als kleur. */
  function isLicht(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      if (n.classList.contains('kk-nacht')) return false;
      var cs = getComputedStyle(n);
      var vlak = kleuren(cs.backgroundColor)[0];
      if (vlak && vlak.a >= 0.5) return helderheid(vlak) > 0.5;
      if (cs.backgroundImage && cs.backgroundImage.indexOf('gradient') !== -1) {
        var ks = kleuren(cs.backgroundImage).filter(function (k) { return k.a >= 0.5; });
        if (ks.length) {
          var som = 0;
          ks.forEach(function (k) { som += helderheid(k); });
          return som / ks.length > 0.5;
        }
      }
    }
    return false;
  }

  /* ---------- aanhangen ---------- */

  function maakSpan(klasse) {
    var s = document.createElement('span');
    s.className = klasse;
    return s;
  }

  /* Eerst alles meten, dan pas alles bouwen. Meten en bouwen door elkaar
     (per knop getComputedStyle, dan een span erin) dwong bij elke knop een
     nieuwe layout af: ~0,4 s op een telefoon. Het resultaat is identiek. */
  function heeftLaag(host) {
    for (var i = 0; i < host.children.length; i++) {
      if (host.children[i].classList.contains('kkg')) return true;
    }
    return false;
  }

  function meet(host) {
    var cs = getComputedStyle(host);
    var knipt = cs.overflowX !== 'visible' || cs.overflowY !== 'visible';
    return {
      altijd: host.matches(altijdSelector),
      knipt: knipt,
      statisch: cs.position === 'static',
      rand: [cs.borderTopWidth, cs.borderRightWidth, cs.borderBottomWidth, cs.borderLeftWidth],
      /* Een pil staat vaak op 999px; groter dan de halve hoogte heeft geen zin. */
      r: Math.min(parseFloat(cs.borderTopLeftRadius) || 0, host.offsetHeight / 2 || 0),
      licht: isLicht(knipt ? host : host.parentElement || host),
      drieD: cs.transformStyle === 'preserve-3d'
    };
  }

  function bouw(host, m) {
    if (m.statisch) host.classList.add('kkg-rel');
    host.classList.add('kkg-host');

    var laag = maakSpan('kkg ' + (m.knipt ? 'kkg--binnen' : 'kkg--buiten') + (m.altijd ? '' : ' kkg--hover'));
    laag.setAttribute('aria-hidden', 'true');

    if (!m.knipt) {
      laag.style.setProperty('--kkg-rt', m.rand[0]);
      laag.style.setProperty('--kkg-rr', m.rand[1]);
      laag.style.setProperty('--kkg-rb', m.rand[2]);
      laag.style.setProperty('--kkg-rl', m.rand[3]);
    }
    laag.style.setProperty('--kkg-r', m.r + 'px');

    if (m.licht) laag.classList.add('kkg--licht');
    if (m.drieD) laag.classList.add('kkg--3d');

    laag.appendChild(maakSpan('kkg__ring'));
    if (!m.knipt) {
      var halo = maakSpan('kkg__halo');
      var waas = maakSpan('kkg__waas');
      waas.appendChild(maakSpan('kkg__licht'));
      halo.appendChild(waas);
      laag.insertBefore(halo, laag.firstChild);
    }

    host.appendChild(laag);
    kijkers(host, laag, m.altijd);
  }

  /* ---------- beeld ---------- */

  var rustKijker = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (items) {
        items.forEach(function (it) {
          var laag = it.target.__kkg;
          if (laag) laag.classList.toggle('kkg--rust', !it.isIntersecting);
        });
      }, { rootMargin: '120px 0px' })
    : null;

  /* Op een scherm zonder muis gloeit de kaart die midden in beeld staat. */
  var middenKijker = 'IntersectionObserver' in window && !magAanwijzen
    ? new IntersectionObserver(function (items) {
        items.forEach(function (it) {
          var laag = it.target.__kkg;
          if (laag) laag.classList.toggle('kkg--midden', it.isIntersecting);
        });
      }, { rootMargin: '-40% -22% -40% -22%' })
    : null;

  function kijkers(host, laag, altijd) {
    host.__kkg = laag;
    if (rustKijker) rustKijker.observe(host);
    if (!altijd && middenKijker) middenKijker.observe(host);
  }

  /* ---------- zoeken ---------- */

  function zoek(wortel) {
    var lijst = (wortel || document).querySelectorAll(alleSelectors);
    var gekozen = [];
    var gekozenSet = typeof Set === 'function' ? new Set() : null;
    function binnenGekozen(el) {
      if (!gekozenSet) return false;
      for (var p = el.parentElement; p; p = p.parentElement) if (gekozenSet.has(p)) return true;
      return false;
    }
    for (var i = 0; i < lijst.length; i++) {
      var el = lijst[i];
      if (heeftLaag(el)) continue;
      /* Een productkaart die zelf al in een uitgelicht blok met rand staat,
         krijgt er geen tweede bij. */
      if (!el.matches(altijdSelector)) {
        var ouder = el.parentElement && el.parentElement.closest('.kkg-host');
        if (ouder || binnenGekozen(el)) continue;
      }
      gekozen.push(el);
      if (gekozenSet) gekozenSet.add(el);
    }
    var maten = [];
    for (var j = 0; j < gekozen.length; j++) {
      try { maten[j] = meet(gekozen[j]); } catch (e) { maten[j] = null; }
    }
    for (var k = 0; k < gekozen.length; k++) {
      if (!maten[k]) continue;
      try { bouw(gekozen[k], maten[k]); } catch (e) {}
    }
  }

  var wacht = null;
  function straks() {
    if (wacht) return;
    wacht = window.setTimeout(function () { wacht = null; zoek(); }, 250);
  }

  function start() {
    zoek();
    /* De winkelwagen, filters en snel-bekijken tekenen hun opmaak opnieuw.
       Alleen nieuwe knopen tellen; tekst die elke seconde verandert (de
       afteltimer) valt eronder maar kost een enkele querySelectorAll. */
    if ('MutationObserver' in window) {
      new MutationObserver(function (lijst) {
        for (var i = 0; i < lijst.length; i++) {
          var toegevoegd = lijst[i].addedNodes;
          for (var j = 0; j < toegevoegd.length; j++) {
            var k = toegevoegd[j];
            if (k.nodeType === 1 && !(k.classList && k.classList.contains('kkg'))) { straks(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* Kleuren kunnen na het laden nog omslaan (kaikan-verzegeld.js zet
     .kk-nacht). Dan meet de laag opnieuw of hij op licht of donker staat. */
  window.addEventListener('load', function () {
    var lagen = document.querySelectorAll('.kkg');
    var licht = [];
    /* eerst alles lezen ... */
    for (var i = 0; i < lagen.length; i++) {
      var laag = lagen[i], host = laag.parentElement;
      if (!host) { licht[i] = null; continue; }
      var knipt = laag.classList.contains('kkg--binnen');
      licht[i] = isLicht(knipt ? host : host.parentElement || host);
    }
    /* ... dan pas schrijven */
    for (var j = 0; j < lagen.length; j++) {
      if (licht[j] !== null) lagen[j].classList.toggle('kkg--licht', licht[j]);
    }
  });

  document.addEventListener('shopify:section:load', function (e) { zoek(e.target); });
})();
